import Dropdown from 'app/components/Dropdown';
import FilterModel from 'app/components/FilterModel';
import PageLoader from 'app/components/PageLoader';
import PasswordPromptModal from 'app/components/PasswordPromptModal';
import PaginatedTable from 'app/components/table/PaginationTable';
import { useMemo } from 'react';
import { buildPackageColumns, PACKAGE_STATUS_OPTIONS } from './packageColumns';
import usePackageManagement from './usePackageManagement';

const Packages = () => {
  const {
    filteredData,
    totalNumber,
    pageCount,
    pageLoading,
    dataPerPage,
    fetchPackageData,
    isdeleteFiltering,
    isFiltering,
    appliedFilters,
    filterValues,
    setFilterValues,
    isFilterOpen,
    setIsFilterOpen,
    handleFilterSubmit,
    handleFilterCancel,
    resetFilter,
    sectionObj,
    passwordmodelOpen,
    setPasswordmodelOpen,
    passwordVal,
    setPasswordVal,
    handlePasswordModel,
    handlemodelvalues,
  } = usePackageManagement();

  // PaginationTable memoises on the columns array's identity, so a fresh array
  // each render would refetch in a loop. handlePasswordModel is recreated every
  // render, but the gate only calls state setters, so the first render's
  // closures keep working and an empty dependency list is safe.
  const columns = useMemo(
    () =>
      buildPackageColumns({
        onEdit: (row) => handlePasswordModel(row, 'edit'),
        onDelete: (row) => handlePasswordModel(row, 'delete'),
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <div className='cms-content__container'>
        {/* The Action cell calls onEdit/onDelete itself, so handleEdit and
            handleDelete are deliberately not passed to the table. */}
        <PaginatedTable
          sectionObj={sectionObj}
          columns={columns}
          data={filteredData}
          fulldata={filteredData}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          pageLoading={pageLoading}
          fetchData={fetchPackageData}
          isdeleteFiltering={isdeleteFiltering}
          isFiltering={isFiltering}
          values={appliedFilters}
        />

        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleFilterSubmit}
            onCancel={handleFilterCancel}
            resetfilter={resetFilter}
          >
            <div className='offcanvas-item'>
              <Dropdown
                id='packageStatus'
                label='Status'
                name='status'
                options={PACKAGE_STATUS_OPTIONS}
                placeholder='All'
                value={filterValues.status}
                handleChange={(e) =>
                  setFilterValues({ ...filterValues, status: e.target.value })
                }
              />
            </div>
          </FilterModel>
        )}
      </div>

      <PasswordPromptModal
        show={passwordmodelOpen}
        value={passwordVal}
        onChange={setPasswordVal}
        onSubmit={handlemodelvalues}
        onClose={() => setPasswordmodelOpen(false)}
      />

      <PageLoader pageLoading={pageLoading} />
    </>
  );
};

export default Packages;
